import "reflect-metadata";
import "./registerServiceWorker";

import Vue from "vue";
import i18n from "./i18n";
import VeeValidate from "vee-validate";

import store from "./store";
import { UserRoleGuard } from "@apphq/vue-keycloak-iframe";
import { authStore } from "./compose";
import api from "./api/store.js";
import "./logging";
import "./ability";
import router from "./router";

import App from "./App.vue";
import { Button, Title } from "@apphq/vue-base-components";

Vue.config.productionTip = false;

Vue.component("r-title", Title);
Vue.component("r-button", Button);

Vue.use(VeeValidate, {
  locale: i18n.i18next.language,
  classes: true,
  classNames: {
    invalid: "is-danger"
  }
});

/** Restrict routes according to the users role. */
const guard = new UserRoleGuard(authStore, {
  path: "/",
  replace: true
});
guard.checkOnLogin(router);
router.beforeEach(guard.before.bind(guard));

store.registerModule("api", api);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
